module.exports = __webpack_public_path__ + "static/media/8-3.650df348.mp3";